import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { z } from 'zod'

const schema = z.object({
  type: z.string().optional(),
  account: z.number().optional()
})

export const MRWebPageDepositsManageRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: `$id/$bankAccountId/deposits-edit`,
    component: lazyRouteComponent(() => import('./MRWebPageDepositsManage')),
    validateSearch: (search) => schema.parse(search)
  })
